<script>
	import { onMount } from 'svelte';
	import { resolveCondition } from '$lib/utils/resolve-condition';
	import { pageConditions } from './__config/conditions';
	import { app } from '$lib/stores/app/store';
  import {isExperimentArmActive} from '$lib/services/experiments';
	import { PAGES } from '$lib/utils/constants';
	import { AnalyticsService } from '$lib/services/analytics';
	export let data;

	/**
	 * @type {typeof import('svelte').SvelteComponent}
	 */
	let Component; //TODO: NEED TO THINK ABOUT BEST APPROACH FOR THIS FOR SSR

	onMount(async () => {
			if ($app?.meta?.isSmartTvApp) {
				await AnalyticsService.trackClientDebug({
					message: 'Redirecting to /abc/?arm=9100',
				});
				window.location = PAGES.INTERNAL.HOME_AOFLJS;
				return;
			}
      const module = await resolveCondition(pageConditions, $app);
      Component = module.default;
	});
</script>

{#if Component}
	<svelte:component this={Component} pageData={data} />
{/if}
